export default __webpack_public_path__ + "static/media/drag.5a8f3f1e.svg";